const scrollTo = (yCoord, duration, nextPos = 0) => {
    if (yCoord !== nextPos) {
        const interval = 40
        const id = setInterval(() => {
            let calculatedNextPos = yCoord > nextPos ? nextPos + interval : nextPos - interval
            if ((calculatedNextPos < (yCoord + interval)) && (calculatedNextPos > (yCoord - interval))) {
                calculatedNextPos = yCoord
            }
            scrollTo(yCoord, duration, calculatedNextPos, id)
            window.scrollTo(0, nextPos)
            clearInterval(id)
        }, 1)
    }
}

export default scrollTo
